export const CATEGORY_ACTION = {
  CREATE: 'CATEGORIES_CREATE',
  VIEW: 'CATEGORIES_VIEW',
  LIST: 'CATEGORIES_LIST',
  UPDATE: 'CATEGORIES_UPDATE',
  DELETE: 'CATEGORIES_DELETE',
  FETCH_HIERARCHICAL: 'FETCH_HIERARCHICAL',
  HOME_CATEGORIES: 'HOME_CATEGORIES',
  FILTERS: 'CATEGORIES_FILTERS'
};